module.exports = __webpack_public_path__ + "images/emoji/thumbsup.0f835ee6eaa6708bb927.png";